import { Colors, Lightning } from '@lightningjs/sdk';

interface AbstractVideoOverlayTemplateSpec
  extends Lightning.Component.TemplateSpec {
  alpha: number;
  TopGradient: object;
  BottomGradient: object;
}

type This = AbstractVideoOverlay<AbstractVideoOverlayTemplateSpec>;

const GRADIENT_WIDTH = 1920;
const TOP_GRADIENT_HEIGHT = 391;
const BOTTOM_GRADIENT_HEIGHT = 1080;

const TRANSITION_DURATION = {
  IMMEDIATE: 0,
  SMOOTH: 0.3,
};

export default abstract class AbstractVideoOverlay<
  TemplateSpec extends Lightning.Component.TemplateSpec,
  TypeConfig extends Lightning.Component.TypeConfig = Lightning.Component.TypeConfig,
> extends Lightning.Component<
  AbstractVideoOverlayTemplateSpec & TemplateSpec,
  TypeConfig
> {
  private enabledOverlay = true;

  static override _template(): Lightning.Component.Template<AbstractVideoOverlayTemplateSpec> {
    return {
      alpha: 0,
      TopGradient: {
        w: GRADIENT_WIDTH,
        h: TOP_GRADIENT_HEIGHT,
        colorTop: Colors('background').get(),
        colorBottom: Colors('transparent').get(),
        rect: true,
      },
      BottomGradient: {
        w: GRADIENT_WIDTH,
        h: BOTTOM_GRADIENT_HEIGHT,
        colorTop: Colors('transparent').get(),
        colorBottom: Colors('background').get(),
        rect: true,
      },
    };
  }

  hide(smooth = true) {
    (this as This).setSmooth('alpha', 0, {
      duration: smooth
        ? TRANSITION_DURATION.SMOOTH
        : TRANSITION_DURATION.IMMEDIATE,
    });
  }

  show() {
    if (this.enabledOverlay) {
      (this as This).setSmooth('alpha', 1, {
        duration: TRANSITION_DURATION.SMOOTH,
      });
    }
  }

  enableOverlay() {
    this.enabledOverlay = true;
  }

  disableOverlay() {
    this.enabledOverlay = false;
    this.hide();
  }
}
